
import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import './AuditList.css'
import share from "./share.png";
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Support from '../contact-popup-module/Support'
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from 'moment'
import ShareAuditOptions from '../audit-creation-module/inspection-mode/ShareAuditOptions'
import { useSwipeable } from 'react-swipeable'
import { saveAs } from 'file-saver'
import Claim from './Claim';

const AuditList = () => {
  const downloadIcon = `${process.env.PUBLIC_URL}/custom-icons/download.svg`
  const calendar = `${process.env.PUBLIC_URL}/custom-icons/calendar.png`
  const menuIcon = `${process.env.PUBLIC_URL}/custom-icons/menu-icon.png`
  const infoIcon = `${process.env.PUBLIC_URL}/custom-icons/info-icon.png`
  const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`
  const searchIcon = `${process.env.PUBLIC_URL}/custom-icons/search.svg`
  const next = `${process.env.PUBLIC_URL}/custom-icons/next-arrow.png`
  const upArrow = `${process.env.PUBLIC_URL}/custom-icons/upArrow.svg`
  const downArrow = `${process.env.PUBLIC_URL}/custom-icons/downArrow.svg`
  
  const location = useLocation()
  const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))

  const userID = location.state?.userId || insuranceUser?.userId
  const [groupedAudits, setGroupedAudits] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [showGroupView, setShowGroupView] = useState(true);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'new')
  const [currentFilter, setCurrentFilter] = useState('all')
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const popupRef = useRef(null)
  const navigate = useNavigate()
  const [audits, setAudits] = useState([])
  const [agentDetails, setAgentDetails] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [open, setOpen] = useState(false)
  const [openSharePopup, setOpenSharePopup] = useState(false)
  const [selectedAuditUrl, setSelectedAuditUrl] = useState('')
  const [dialogWidth, setDialogWidth] = useState('29vw')
  const [isAscending, setIsAscending] = useState(false)
  const [audit_status, setAuditStatus] = useState(null)
  const [formDetailsMap, setFormDetailsMap] = useState({})
  const [allInfoLoaded, setAllInfoLoaded] = useState(false)
  const [loadingComplete, setLoadingComplete] = useState(false)
  const [counts, setCounts] = useState({ new: 0, inProgress: 0, inactive: 0, claim: 0 })
  const [sortedAudits, setSortedAudits] = useState([])

  const [partDetailsMap, setPartDetailsMap] = useState({}) // ✅ new state for part details
  
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab)
    }
  }, [location.state])

  useEffect(() => {
    const fetchAuditsAndDetails = async () => {
      setLoading(true);

      try {
        if (!userID) {
          console.error('User ID is missing');
          setLoading(false);
          return;
        }

        const [auditResponse, agentResponse] = await Promise.all([
          axios.post('/agentApis/getAgentAllAuditInfo', { userID }),
          axios.post('/agentApis/getCompleteAgentInfo', { userID })
        ]);

        let auditData = auditResponse.data
          .filter(item => item.used !== "expired") 
          .map(item => {
            const leadTime = item.lead_creation_time || '';
            const [date = '--', time = '--'] = leadTime.split(' ');

            return {
              id: item.audit,
              date,
              time,
              used: item.used,
              status: 'new', 
              type: ['Inspection'],
              mode: item.audit_mode,
              originalUsedStatus: item.used 
            };
          });

        // Batch fetch audit details
        const auditIds = auditData.map(audit => audit.id);

        const detailsResponse = await axios.post('/process_data/batch_check_and_get_details', {
          auditIds
        });

        const fetchedDetails = detailsResponse.data.audits;

        // Merge fetched details with auditData
        const auditDataWithDetails = auditData.map(audit => {
          const found = fetchedDetails.find(item => item.id === audit.id);
          return {
            ...audit,
            Make: found?.details.Make || '',
            Model: found?.details.Model || '',
            'Name of Customer': found?.details["Farmer's Name"] || ' ',
            'Address': found?.details["Farmer's Address"] || ' '
          };
        });

        setAudits(auditDataWithDetails);

        // ✅ Fetch partDetails for triple tick
        const fetchPartDetails = async () => {
          const tempMap = {};
          await Promise.all(
            auditDataWithDetails.map(async (audit) => {
              try {
                const res = await axios.post('/process_data/get-partdetails', { audit_id: audit.id });
                tempMap[audit.id] = res.data?.data?.muzzleRemark2 || null;
              } catch (err) {
                console.error("partdetails error:", err);
                tempMap[audit.id] = null;
              }
            })
          );
          setPartDetailsMap(tempMap);
        };

        fetchPartDetails();

        // Compute status counts
        const computedCounts = {
          new: auditDataWithDetails.length,
          inProgress: 0,
          inactive: 0
        };
        setCounts(computedCounts);

        // GROUP AUDITS BY PREFIX
        const grouped = auditDataWithDetails.reduce((acc, audit) => {
          const groupId = audit.id.split('_')[0];
          if (!acc[groupId]) acc[groupId] = [];
          acc[groupId].push(audit);
          return acc;
        }, {});
        setGroupedAudits(grouped);

        if (agentResponse.status === 200) {
          setAgentDetails(agentResponse.data[0]);
        } else {
          setError('Failed to fetch agent details');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('An error occurred while fetching data');
      } finally {
        setLoadingComplete(true);
        setLoading(false);
      }
    };

    fetchAuditsAndDetails();
  }, [userID]);

  const handleGroupClick = (groupId) => {
    setSelectedGroup(groupId);
    setShowGroupView(false);
  };

  const handleBackToGroups = () => {
    setSelectedGroup(null);
    setShowGroupView(true);
  };

  // ✅ Final getReadReceipt function with triple tick
  // const getReadReceipt = (audit) => {
  //   let tick = audit.used === "processed" ? "✓✓" : "✓";

  //   const partData = partDetailsMap[audit.id];
  //   if (partData === "Muzzle ID is found in Database" ||
  //       partData === "Muzzle ID is not found in Database") {
  //     tick = "✓✓✓";
  //   }
  //   return tick;
  // };
const getReadReceipt = (audit) => {
  let tick = "✓";
  let color = "black";

  // Case 2: processed → double black tick
  if (audit.used === "processed") {
    tick = "✓✓";
  }

  // Case 3: partData condition → double blue tick (override)
  const partData = partDetailsMap[audit.id];
  if (
    partData === "Muzzle ID is found in Database" ||
    partData === "Muzzle ID is not found in Database"
  ) {
    tick = "✓✓";
    color = "#2196F3"; // blue
  }

  return { tick, color };
};
  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth
      if (windowWidth <= 450) setDialogWidth('94vw')
      else if (windowWidth <= 475) setDialogWidth('94vw')
      else if (windowWidth <= 575) setDialogWidth('64vw')
      else if (windowWidth <= 650) setDialogWidth('60vw')
      else if (windowWidth <= 775) setDialogWidth('57vw')
      else if (windowWidth <= 875) setDialogWidth('55vw')
      else if (windowWidth <= 1000) setDialogWidth('48vw')
      else if (windowWidth <= 1100) setDialogWidth('45vw')
      else if (windowWidth <= 1300) setDialogWidth('40vw')
      else setDialogWidth('35vw')
    }

    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const tabsRef = useRef({})

  const handleTabClick = tab => {
    if (tab === 'inactive') return;
    setActiveTab(tab)
    tabsRef.current[tab]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
  }

  const getButtonLabel = (audit) => audit.used === "processed" ? "More Info" : "Start";

  const handleNavigateClick = (audit) => {
    if (audit.used === "processed") {
      navigate(`/AuditDesc/${audit.id}`, { state: { audit, userID, agentDetails, activeTab } });
    } else {
      navigate(`/auditDescription`, { state: { audit, userID, agentDetails, activeTab } });
    } 
  };

  const tabs = ['new', 'renewal', 'claim']

  const [swiping, setSwiping] = useState(false)

  const swipeHandlers = useSwipeable({
    onSwiping: () => setSwiping(true),
    onSwiped: () => setSwiping(false),
    onSwipedLeft: () => {
      const currentIndex = tabs.indexOf(activeTab);
      if (currentIndex < tabs.length - 1 && tabs[currentIndex + 1] !== 'inactive') handleTabClick(tabs[currentIndex + 1]);
    },
    onSwipedRight: () => {
      const currentIndex = tabs.indexOf(activeTab)
      if (currentIndex > 0) handleTabClick(tabs[currentIndex - 1])
    },
    delta: 80,
    trackTouch: true,
    preventScrollOnSwipe: true
  })

  const handleClickOutside = event => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsPopupVisible(false)
    }
  }

  useEffect(() => {
    if (isPopupVisible) document.addEventListener('mousedown', handleClickOutside)
    else document.removeEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isPopupVisible])
  
  const handleAddClick = async () => {
    try {
      const response = await axios.post('/create_audit/check_audit_limit', { userID });
      if (response.data.success && response.data.hasReachedLimit) {
        toast.error("You can't create audit now, you have reached the limit", { position: 'bottom-center', autoClose: 4000 });
        return;
      }
      navigate('/home');
    } catch (error) {
      toast.error('Failed to verify audit limit. Please try again.', { position: 'bottom-center', autoClose: 3000 });
    }
  };

  const handleAddClick2 = async () => {
    try {
      const response = await axios.post('/create_audit/check_audit_limit2', { userID });
      if (response.data.success && response.data.hasReachedLimit) {
        toast.error("You can't create audit now, you have reached the limit", { position: 'bottom-center', autoClose: 4000 });
        return;
      }
      navigate('/ClaimNewAudit');
    } catch (error) {
      toast.error('Failed to verify audit limit. Please try again.', { position: 'bottom-center', autoClose: 3000 });
    }
  };

  const handleClickOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleLogout = () => {
    localStorage.removeItem('insuranceUser');
    localStorage.removeItem('inspectionConfig');
    navigate('/login', { replace: true });
  };
  
  const [filteredAudit, setFilteredAudit] = useState([])
  const filteredAudits = selectedGroup
    ? groupedAudits[selectedGroup] || []
    : (filteredAudit.length > 0 ? filteredAudit : audits)
        .filter(audit => audit.status === activeTab);

  const handleSearch = query => {
    const filtered = audits.filter(
      audit => audit['Name of Customer'].toLowerCase().includes(query.toLowerCase()) ||
               audit['id'].toLowerCase().includes(query.toLowerCase())
    )
    setFilteredAudit(filtered)
  }

  const [sortOrder, setSortOrder] = useState('desc')
  const handleDateSort = () => setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc')
const getParentTick = (groupAudits) => {
  let hasSingle = false;
  let hasBlack = false;
  let hasBlue = false;

  groupAudits.forEach((audit) => {
    const receipt = getReadReceipt(audit);

    if (receipt.tick === "✓") hasSingle = true;
    else if (receipt.tick === "✓✓" && receipt.color === "#2196F3") hasBlue = true;
    else if (receipt.tick === "✓✓") hasBlack = true;
  });

  // Rule 1: if ANY single → parent = single
  if (hasSingle) {
    return { tick: "✓", color: "gray" };
  }

  // Rule 2: if black exists → parent = black
  if (hasBlack) {
    return { tick: "✓✓", color: "black" };
  }

  // Rule 3: only blue → parent = blue
  if (hasBlue) {
    return { tick: "✓✓", color: "#2196F3" };
  }

  return { tick: "", color: "" };
};
  return (
    <div className='audit-list-container'>
      {/* Header */}
      <div className='header-container'>
        <h1>Assigned Cattle Insurance</h1>
        <img src={menuIcon} alt='Options' className='three-dots-icon' onClick={() => setIsPopupVisible(!isPopupVisible)} />
        {isPopupVisible && (
          <div className='popup-menu' ref={popupRef}>
            <button className='popup-item' onClick={handleClickOpen}>
              <img src={infoIcon} alt='Info' className='info-icon' /> Help
            </button>
            <button className='popup-item' onClick={handleLogout}>Logout</button>
          </div>
        )}
      </div>
      
      <Dialog open={open} onClose={handleClose} className='support-popup-dialog'>
        <DialogContent className='support-popup-content'>
          <Support />
          <button onClick={handleClose} className='close-btn'>close</button>
        </DialogContent>
      </Dialog>

      {/* Tabs */}
      <div className='tabs-container'>
        <div className='tabs'>
          <button className={activeTab === 'new' ? 'active' : ''} onClick={() => handleTabClick('new')} ref={el => (tabsRef.current['new'] = el)}>
            New Insurance <span className='count'>{counts.new}</span>
          </button>
          <button className={`${activeTab === 'inactive' ? 'active' : ''} inactive-tab`} onClick={() => handleTabClick('inactive')} disabled style={{ opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' }}>
            Renewal <span className='count'>{counts.new}</span>
          </button>
          <button className={activeTab === 'claim' ? 'active' : ''} onClick={() => handleTabClick('claim')} ref={el => (tabsRef.current['claim'] = el)}>
            Claim <span className='count'>{counts.claim}</span>
          </button>
        </div>
      </div>

      {/* Claim tab */}
      {activeTab === 'claim' && <Claim userID={userID} activeTab={activeTab} onCountUpdate={count => setCounts(prev => ({ ...prev, claim: count }))} />}

      {/* Non-claim tabs */}
      {activeTab !== 'claim' && (
        <>
          <div className='filters'>
            <div className='search-container'>
              <input type='text' placeholder='Search' className='search-input' onChange={e => handleSearch(e.target.value)} />
              <img src={searchIcon} alt='Search Icon' className='search-icon' />
            </div>
          </div>

          {!loadingComplete ? (
            <div className='loader-container'><CircularProgress style={{ color: '#FC350B' }} size={40} /></div>
          ) : audits.length === 0 ? (
            <div className='no-audit-message'></div>
          ) : (
            <div {...swipeHandlers} className={`audit-cards ${swiping ? 'swiping' : ''}`}>
              {showGroupView ? (
                <div className="audit-cards">
                                {Object.keys(groupedAudits).map(groupId => {
                const parentReceipt = getParentTick(groupedAudits[groupId]);

                return (
                  <div
                    className="audit-card"
                    key={groupId}
                    onClick={() => handleGroupClick(groupId)}
                  >
                    <div className="audit-header">
                      <div className="header-one">
                        <p className="audit-id">{groupId}</p>
                      </div>

                      <div className="header-two">
                        <p>{groupedAudits[groupId].length} audits</p>

                        <span
                          style={{
                            fontSize: "14px",
                            color: parentReceipt.color
                          }}
                        >
                          {parentReceipt.tick}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
                </div>
              ) : (
                <div>
                  <button style={{marginBottom:'10px'}} onClick={handleBackToGroups}>← Back to Groups</button>
                  <div {...swipeHandlers} className={`audit-cards ${swiping ? 'swiping' : ''}`}>
                  {filteredAudits
  .slice()
  .sort((a, b) => {
    const dateA = moment(`${a.date} ${a.time}`, 'DD-MM-YYYY HH:mm').toDate()
    const dateB = moment(`${b.date} ${b.time}`, 'DD-MM-YYYY HH:mm').toDate()
    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA
  })
  .map(audit => {
    const receipt = getReadReceipt(audit); // ✅ correct placement

    return (
      <div className='audit-card' key={audit.id}>
       <div className='audit-header'>
  <div className='header-one'>
    <p className='audit-id'>{audit.id}</p>
  </div>

  <div className='header-two'>
    <div className='date-container'>
      <img src={calendar} className='calendar-icon' alt="calendar" />
      <p>{audit.date}</p>
    </div>

    <p>{audit.time}</p>

    <span
      style={{
        fontSize: "14px",
        color: receipt.color
      }}
    >
      {receipt.tick}
    </span>
  </div>
</div>

        <div className='audit-actions'>
          <button
            className='navigate-button'
            onClick={() => handleNavigateClick(audit)}
          >
            {getButtonLabel(audit)}
            <img src={next} alt='Next' className='next-arrow' />
          </button>
        </div>
      </div>
    );
  })}
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
      {activeTab === 'new' && (
        <button className='fab' onClick={() => handleAddClick()}>
          +
        </button>
      )}
      
      {activeTab === 'claim' && (
        <button className='fab' onClick={() => handleAddClick2()}>
          +
        </button>
      )}
      
      <ToastContainer />
    </div>
  )
}

export default AuditList